/**
 * 引导用户去“我的”页面，收取金币
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../lang/index';
import DialogHOC  from './dialog-hoc';
import api from '../global/api';
import http from '../global/http';
import cache from '../global/cache';
import notification from 'c-notification';

class Dialog  extends Component {
	
	render() {
		

		return (
			<div className="popup-wrapper popup-notice-wrapper">

				<div className="box-hd">
					<div className="title">
					{lang.template('汇款注意事项')}
					</div>
					<div className="close" onClick={this.props.handleCancel}></div>
				</div>
				<div className="content">
					<h3>{lang.template('注意事项：')}</h3>
					<div className="notice-detail" dangerouslySetInnerHTML={{__html: lang.template("注意事项详情")}}></div>

					<h3>{lang.template('储值服务时间：')}</h3>
					<div className="notice-detail time-detail" dangerouslySetInnerHTML={{__html: lang.template("储值服务时间详情")}}></div>
					<div className="notice-detail" dangerouslySetInnerHTML={{__html: lang.template("银行汇款到账提示详情")}}></div>

				</div>
				<div className="box-fd">
					<div className="btn" onClick={this.props.handleCancel}>{lang.template('知道了')}</div>
				</div>
			</div>


				
		);
	}
}

const NewDialog = DialogHOC(Dialog);

module.exports = {
	create: function (cfg) {
		cfg = cfg || {};
		
		if (this.layer) {
			this.destroy();
		}
		var mountNode = this.createMountNode();
		
		this.layer = ReactDOM.render(
			<NewDialog {...cfg} onHide={this.onHide.bind(this)} />,
			mountNode
		);
	},
	onHide: function(){
		this.destroy();
	},
	// 创建组件插入的DOM节点
	createMountNode: function() {
		this.mountNode = document.createElement("div");
		$(document.body).append(this.mountNode);
		return this.mountNode;
	},
	destroy : function () {
		ReactDOM.unmountComponentAtNode(this.mountNode);
		$(this.mountNode).remove();
		delete this.layer;
	}
};


// WEBPACK FOOTER //
// ./js/popup/dialog-notice.js